
/** px 转 rem */
export function pxToRem(number: number) {
  if (isNaN(number)) return 'auto'
  return `${number / 100}rem`
} 